module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/HISTORY-d5d64c6a3ae6f0a4db4c7f794f8f96a6.png";